import { queryClient } from "@core-shop/providers/QueryProvider";
import { EntityKey } from "./types";

export const invalidate = {
  storefront: queryClient.invalidateQueries([EntityKey.STOREFRONT]),
  viewer: queryClient.invalidateQueries([EntityKey.VIEWER]),
};
